import { Inject, Injectable, InjectionToken } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

@Injectable({ providedIn: 'root' })
export class TimeoutInterceptor implements HttpInterceptor {
  constructor(@Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutHeader = req.headers.get('timeout');
    const timeoutValueNumeric = Number(timeoutHeader || this.defaultTimeout);

    // The header is client-side only: forwarding it would make cross-origin chunk fetches preflighted.
    const forwardedRequest = timeoutHeader ? req.clone({ headers: req.headers.delete('timeout') }) : req;

    return next.handle(forwardedRequest).pipe(timeout(timeoutValueNumeric));
  }
}
